import { Button } from '@bambi/component-library/src/components/Button';
import { Popover } from '@bambi/component-library/src/components/Popover/Popover';
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ClockIcon,
  UserIcon,
} from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import {
  setUnassignedTripsSorting,
  setUnassignedTripsSortingDirection,
  UnassignedTripsSorting,
} from 'src/features/dispatch/dispatcher.slice';

const sortingOptions: Array<{
  label: string;
  value: UnassignedTripsSorting;
  icon: React.ReactNode;
}> = [
  {
    label: 'Scheduled Pickup Time',
    value: 'scheduled_pickup_time',
    icon: <ClockIcon className="mr-2 h-4 w-4" />,
  },
  {
    label: 'Passenger Name',
    value: 'passenger__full_name',
    icon: <UserIcon className="mr-2 h-4 w-4" />,
  },
];

export function UnassignedTripsSortMenu() {
  const dispatch = useAppDispatch();
  const currentSorting = useAppSelector(
    (state) => state.dispatcher.unassignedTripsSorting
  );
  const currentSortingDirection = useAppSelector(
    (state) => state.dispatcher.unassignedTripsSortingDirection
  );

  const handleSortingChange = (sorting: UnassignedTripsSorting) => {
    dispatch(setUnassignedTripsSorting(sorting));
    dispatch(
      setUnassignedTripsSortingDirection(
        currentSortingDirection === 'asc' ? 'desc' : 'asc'
      )
    );
  };

  return (
    <Popover
      trigger={
        <Button className="mr-2" dataTestId="unassigned-trips-sort-menu-btn">
          Sorting
        </Button>
      }
      content={
        <div className="flex flex-col items-start gap-2">
          {sortingOptions.map((option) => {
            let icon = option.icon;

            if (currentSorting === option.value) {
              icon =
                currentSortingDirection === 'asc' ? (
                  <ArrowUpIcon
                    className="mr-2 h-4 w-4"
                    data-testid="arrow-up-icon"
                  />
                ) : (
                  <ArrowDownIcon
                    className="mr-2 h-4 w-4"
                    data-testid="arrow-down-icon"
                  />
                );
            }

            return (
              <Button
                variant="ghost-icon"
                key={option.value}
                onClick={() => handleSortingChange(option.value)}
              >
                {icon} {option.label}
              </Button>
            );
          })}
        </div>
      }
    />
  );
}
